module.exports = __webpack_public_path__ + "static/media/mmsys_120.cd74318e.ico";